import styled from "styled-components";

//This is a styled component that keeps style for any container throught the website

export const Container = styled.div`
  width: 100%;
  padding: 0rem 12rem;
`;